import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import "./CreateTask.css";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "lodash";
import { weekdaysShort } from "moment";
export default function Add_Recorning() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [names, setNames] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const Id = useSelector((state) => state.id);
  const [searchText, setSearchText] = useState("");

  function convertTo12Hour(timeStr) {
    if (!timeStr) return "";
    const [hourStr, minuteStr] = timeStr.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12.toString().padStart(2, "0")}:${minuteStr} ${ampm}`;
  }

  const staffName = useSelector((state) => state.staffname);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [approvePerson, setApprovePerson] = useState(null); // initially no one selected
  const [approvePersons, setApprovePersons] = useState([]); // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);

  const [selectedNames, setSelectedNames] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [taskData, setTaskData] = useState({
    taskName: "",
    taskType: "",
    // taskType: 'Once',
    taskPriority: "Low",
    deadlineDays: "01",
    // time: '',
    assignedTo: [], // Array for multiple selections
    approvePerson: "",
    description: "",
    name: "",
    leadId: "",
    taskStatus: "Open",
    assignedBy: "",
    recurringStatus: "Active",

    time: "",
    weekday: "",
    date: "",
  });
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleInputChange = (field, value) => {
    setTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const filteredNames = staffData.filter((staff) =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  console.log("Filtered Names:", filteredNames); // Debugging log
  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch staff whole data for dropdown
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setStaffData(res.data.message);

        console.log(res.data.message);
      });
  }, [apiUrl]);

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  // Display text: show staff names of selected IDs
  const displayText =
    selectedNames.length > 0
      ? selectedNames.map((item) => item.staffName).join(", ")
      : "Select names";

  const assignedTo = selectedNames; // [{_id, staffName}, {_id, staffName}, ...]

  const approvePersonDisplay = approvePerson
    ? approvePerson.staffName
    : "Select Approve Person";

  // Display selected staff names joined by comma, or default text

  const handleApprovePersonChange = (staff) => {
    setApprovePerson(staff); // just set the selected staff object
  };

  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const isSelected = prev.some((item) => item._id === staff._id);
      if (isSelected) {
        return prev.filter((item) => item._id !== staff._id); // remove if unchecked
      } else {
        return [...prev, staff]; // add if checked
      }
    });
  };

  // useEffect(() => {
  //   const defaultApproved = staffData.filter((staff) => {
  //     return (
  //       staff.designation
  //     );
  //   });

  //   setApprovePersons(defaultApproved);
  // }, [staffData]);

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    // setTaskData(prev => ({
    //   ...prev,
    //   taskType: formattedDate
    // }));
  }, []);

  const navi = useNavigate();

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  function gototaskPage() {
    navi("/task");
  }

  const [IsOpenTask, setIsOpenTask] = useState(false);
  const [IsUpdateHistory, setIsUpdateHistory] = useState(false);
  const [IsShowUploadTask, setIsShowUploadTask] = useState(false);
  const [IsDotBox, setIsDotBox] = useState(false);

  function showOpenTask() {
    setIsOpenTask(true);
  }
  const toggleApproveDropdown = () => {
    setIsApproveOpen((prev) => !prev);
  };

  const approvePersonText =
    approvePersons.length > 0
      ? approvePersons.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        approveDropdownRef.current &&
        !approveDropdownRef.current.contains(event.target)
      ) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Convert 24-hour time to 12-hour with AM/PM
          let convertedTime = taskData.time;

          if (taskData.time) {
            const [hourStr, minuteStr] = taskData.time.split(":");
            const hour = parseInt(hourStr, 10);
            const minute = parseInt(minuteStr, 10);
            const ampm = hour >= 12 ? "PM" : "AM";
            const hour12 = hour % 12 === 0 ? 12 : hour % 12;
            convertedTime = `${hour12
              .toString()
              .padStart(2, "0")}:${minuteStr} ${ampm}`;
          }

          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            time: convertedTime,
            assignedBy: {
              staffName: staffName,
              id: Id,
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
          };

          // Required fields
          let requiredFields = [
            "taskName",
            "taskType",
            "deadlineDays",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          if (taskData.taskType === "Daily") {
            requiredFields.push("time");
          } else if (taskData.taskType === "Weekly") {
            requiredFields.push("time", "weekday");
          } else if (taskData.taskType === "Monthly") {
            requiredFields.push("time", "date");
          }

          // Validate required fields
          const emptyFields = requiredFields.filter((field) => {
            const value = datas[field];
            if (Array.isArray(value)) return value.length === 0;
            if (typeof value === "string") return value.trim() === "";
            return !value;
          });

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all required fields.`,
            });
            return;
          }

          // Submit data
          await axios.post(apiUrl + "add-recurring-task", datas, {
            headers: { "Content-Type": "application/json" },
          });

          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            // Optional reset
            // setTaskData(initialState);
            // navigate("/recurring");
          });
        } catch (error) {
          console.log(
            "Error submitting data:",
            error.response?.data || error.message
          );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };

  return (
    <div>
      <Topbar />
      <Container className="mt-1">
        <Row className="ct-mainhead">
          <Col>
            <h3>Recurring Task</h3>
          </Col>

          <Col className="text-end">
            <button
              className="bluetask-btn px-4 text-white"
              value="submit"
              type="submit"
              // onClick={gototaskPage}
              onClick={handleSubmitAssignTask}
            >
              Submit
            </button>
          </Col>
        </Row>
        <Row className="task-create-container">
          <div className="task-shadow">
            <form>
              <h6 className="create-task-head">Create Recurring Task</h6>
              <div className="create-task-head-1">
                <Row className="g-5">
                  <Col sm={12} md={6} style={{ marginTop: "68px" }}>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Name
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          onChange={(e) =>
                            handleInputChange("taskName", e.target.value)
                          }
                          name="taskName"
                          className="form-input"
                          placeholder="Enter Task Name"
                          required
                          style={{ textTransform: "capitalize" }}
                        />
                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <label className="rowdown">Task Type</label>
                        <br />
                        <select
                          value={taskData.taskType}
                          onChange={(e) =>
                            handleInputChange("taskType", e.target.value)
                          }
                          className="dropbtn form-input-select overlay2"
                          required
                        >
                          <option value="">Select</option>
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                        </select>
                      </Col>

                      {/* Daily & Weekly & Monthly — Show Time */}

                      {/* Weekly — Show Weekday */}
                    </Row>
                    <Row>
                      <Col xs={12} md={6} className="text-start">
                        <label>Task Assign To</label>
                        <br />
                        <div
                          ref={dropdownRef}
                          style={{ position: "relative", width: "85%" }}
                        >
                          <div
                            onClick={toggleDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {displayText}
                            </span>
                            <span>{isOpen ? "▲" : "▼"}</span>
                          </div>

                          {isOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{
                                  width: "95%",
                                  margin: "10px auto",
                                  display: "block",
                                  padding: "8px",
                                  borderRadius: "4px",
                                  border: "1px solid #ccc",
                                }}
                              />

                              {/* Filtered Staff List */}
                              {staffData
                                .filter((staff) =>
                                  [
                                    "Admin",
                                    "Super Admin",
                                    "Network Admin",
                                    "Accounts Admin",
                                    "Marketing Admin",
                                    "Network Engineer",
                                    "Marketing/Fiber",
                                    "Accountant",
                                    "Tele Calling",
                                  ].includes(staff.designation)
                                )
                                .filter((staff) =>
                                  staff.staffName
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                ).length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No Staffs found
                                </div>
                              ) : (
                                staffData
                                  .filter((staff) =>
                                    [
                                      "Admin",
                                      "Super Admin",
                                      "Network Admin",
                                      "Accounts Admin",
                                      "Marketing Admin",
                                      "Network Engineer",
                                      "Marketing/Fiber",
                                      "Accountant",
                                      "Tele Calling",
                                    ].includes(staff.designation)
                                  )
                                  .filter((staff) =>
                                    staff.staffName
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  )
                                  .map((staff) => (
                                    <label
                                      key={staff._id}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectedNames.some(
                                          (item) => item._id === staff._id
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(staff)
                                        }
                                        style={{ marginRight: "10px" }}
                                        required
                                      />
                                      {staff.staffName || "(No Name)"}
                                    </label>
                                  ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12} md={6} className="text-start">
                        <label>Approve Person</label>
                        <br />
                        <div
                          ref={approveDropdownRef}
                          style={{
                            position: "relative",
                            width: "85%",
                            marginTop: "15px",
                          }}
                        >
                          <div
                            onClick={toggleApproveDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "-5px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {approvePersonText}
                            </span>
                            <span>{isApproveOpen ? "▲" : "▼"}</span>
                          </div>

                          {isApproveOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "8px 10px",
                                  borderBottom: "1px solid #ccc",
                                  boxSizing: "border-box",
                                  outline: "none",
                                  border: "none",
                                }}
                              />

                              {/* 🧑‍💼 Filtered Staff List */}
                              {filteredNames.length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No staff found
                                </div>
                              ) : (
                                filteredNames.map((staff) => (
                                  <label
                                    key={staff._id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "10px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #eee",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      required
                                      checked={approvePersons.some(
                                        (item) => item._id === staff._id
                                      )}
                                      onChange={() =>
                                        handleApproveCheckboxChange(staff)
                                      }
                                      style={{ marginRight: "10px" }}
                                    />
                                    {staff.staffName || "(No Name)"}
                                  </label>
                                ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12} md={12} className="text-start mt-4">
                        <lable>Description</lable>
                        <br />
                        <textarea
                          type="text"
                          onChange={(e) =>
                            handleInputChange("description", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                          className="form-input inputfield-assign "
                          placeholder="Enter Notes "
                          required
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      {(taskData.taskType === "Daily" ||
                        taskData.taskType === "Weekly" ||
                        taskData.taskType === "Monthly") && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Time</label>
                          <br />
                          <input
                            type="time"
                            className="form-input"
                            value={taskData.time}
                            onChange={(e) =>
                              handleInputChange("time", e.target.value)
                            }
                            required
                          />
                        </Col>
                      )}

                      {taskData.taskType === "Weekly" && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Weekday</label>
                          <br />
                          <select
                            className="dropbtn form-input-select"
                            value={taskData.weekday}
                            onChange={(e) =>
                              handleInputChange("weekday", e.target.value)
                            }
                            required
                          >
                            <option value="">Select Weekday</option>
                            {weekdays.map((day) => (
                              <option key={day} value={day}>
                                {day}
                              </option>
                            ))}
                          </select>
                        </Col>
                      )}

                      {/* Monthly — Show Date */}
                      {taskData.taskType === "Monthly" && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Date</label>
                          <br />
                          <select
                            required
                            onChange={(e) =>
                              handleInputChange("date", e.target.value)
                            }
                            className="dropbtn form-input-select overlay2"
                            value={taskData.date} // Optional: to control selected value
                          >
                            <option value="">Select Date </option>
                            {Array.from({ length: 31 }, (_, i) => {
                              const value = String(i + 1).padStart(2, "0");
                              return (
                                <option key={value} value={value}>
                                  {value}
                                </option>
                              );
                            })}
                          </select>
                        </Col>
                      )}
                    </Row>
                    <br />
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <label className="rowdown">Deadline Days</label>
                        <br />

                        <select
                          required
                          onChange={(e) =>
                            handleInputChange("deadlineDays", e.target.value)
                          }
                          className="dropbtn form-input-select overlay2"
                          value={taskData.deadlineDays} // Optional: to control selected value
                        >
                          {Array.from({ length: 10 }, (_, i) => {
                            const value = String(i + 1).padStart(2, "0");
                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </select>
                      </Col>
                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Priority</lable>
                        <br />
                        <select
                          required
                          onChange={(e) =>
                            handleInputChange("taskPriority", e.target.value)
                          }
                          class="dropbtn form-input-select overlay2"
                        >
                          <option value="Low">Low</option>
                          <option value="High">High</option>
                          <option value="Immediate">Immediate</option>
                        </select>
                      </Col>

                      <Col xs={12} md={6} className="text-start mt-3">
                        <lable>Task Status </lable>
                        <br />
                        <input
                          type="text"
                          onChange={(e) =>
                            handleInputChange("taskStatus", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            textAlign: "center",
                            backgroundColor: "#fbdc6e",
                            color: "rgb(94, 94, 14)",
                            cursor: "pointer",
                          }}
                          className="form-input "
                          value={taskData.taskStatus}
                          readOnly
                        />
                      </Col>
                      <Col xs={12} md={6} className="text-start mt-3">
                        <label>Recurring Status</label>
                        <br />
                        <select
                          name="recurringStatus"
                          value={taskData.recurringStatus || ""}
                          onChange={(e) =>
                            setTaskData((prev) => ({
                              ...prev,
                              recurringStatus: e.target.value,
                            }))
                          }
                          className={`form-input-select dropbtn ${
                            taskData.recurringStatus === "Active"
                              ? "recurring-active"
                              : taskData.recurringStatus === "InActive"
                              ? "recurring-inactive"
                              : ""
                          }`}
                        >
                          <option value="Active" className="option-active">
                            Active
                          </option>
                          <option value="InActive" className="option-inactive">
                            InActive
                          </option>
                        </select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </form>
          </div>
        </Row>

        {IsUpdateHistory && (
          <div className="row historybox mt-5">
            <div className="col">
              <div className="historyLeft">
                <p>
                  K. Saravanan&emsp;<span>2h</span>
                </p>
                <p className="textOrange">Task / Open</p>

                <p
                  className="dotBoxPos"
                  onClick={() => {
                    setIsDotBox(true);
                  }}
                >
                  <span>&#8942;</span>
                  {IsDotBox && (
                    <div className="dotBox">
                      <div className="dorBox1">
                        <p>Approved</p>
                        <p>Delete</p>
                      </div>
                    </div>
                  )}
                </p>
              </div>
            </div>
            <div className="col uhistory px-0">
              <div className="updateHistory">
                <p className="updateHistory_1">
                  <b>Update History</b>
                </p>
              </div>
              <div className="row px-5">
                <div className="historyData">
                  <p>12/12/2024 - 12.30 PM</p>
                  <p>Saravanan</p>
                  <p style={{ color: "#866A04", fontWeight: "bold" }}>Open</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
